import { AnimatePresence } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import { useVote } from './hooks/useVote';

import { Quiz, Randomizer } from 'components';

import styles from './App.module.css';
import defaultBackground from './assets/images/bg.webp';

const BLUR_STATE = 'S1';

const QUIZ_ADVT = 'S2';
const QUIZ_AVATARS = 'S3';
const CORRECT_VAR = 'S4';

const RND_ONE_WIN = 'S5';
const RND_SLOW = 'S6';
const RND_FAST = 'S7';
const RND_WIN = 'S8';
const RND_CLEAR = 'S9';

const VISIBLE_QUIZ = [QUIZ_ADVT, QUIZ_AVATARS, CORRECT_VAR];
const VISIBLE_RND = [RND_ONE_WIN, RND_SLOW, RND_FAST, RND_WIN];

function App() {
  const { voteState, currentState, isFirstState } = useVote(VISIBLE_QUIZ);
  const {
    showedMessages,
    messagesRef,
    winnerMessage,
    speed,
    showedMessagesF2,
  } = useCarousel({
    currentState,
    RND_SLOW,
    RND_FAST,
    RND_WIN,
    RND_CLEAR,
    QUIZ_AVATARS,
  });

  const { bg, bgColor } = useGetParams();
  const background =
    bg && bg !== '0'
      ? `url(${bg === '1' ? defaultBackground : bg}) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;

  return (
    <div
      className={styles.appWrapper}
      style={{ '--speed': `${speed}ms`, background }}
    >
      <div className={styles.titreWrapper}>
        <AnimatePresence mode="wait">
          {VISIBLE_QUIZ.includes(currentState) && (
            <Quiz
              isFirstState={isFirstState} // для задержки анимации правильного варианта
              showedMessagesF2={showedMessagesF2}
              key="quiz"
              voteState={voteState}
              currentState={currentState}
              QUIZ_ADVT={QUIZ_ADVT}
              QUIZ_AVATARS={QUIZ_AVATARS}
              CORRECT_VAR={CORRECT_VAR}
            />
          )}

          {VISIBLE_RND.includes(currentState) && (
            <Randomizer
              key="msgList"
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              currentState={currentState}
              speed={speed || 0}
              messagesRef={messagesRef}
              questionImgUrl={voteState?.questionImgUrl}
              RND_ONE_WIN={RND_ONE_WIN}
              RND_WIN={RND_WIN}
            />
          )}
        </AnimatePresence>

        <div
          className={styles.blurBg}
          style={{
            backdropFilter:
              (VISIBLE_QUIZ.includes(currentState) ||
                BLUR_STATE === currentState) &&
              'blur(4rem)',
          }}
        />
      </div>
    </div>
  );
}

export default App;
